export default "__VITE_ASSET__198cc510__"